import { Component, OnInit } from "@angular/core";
import { DialogService } from "primeng/dynamicdialog";
import { Subscription } from "rxjs";
import { UserService } from "../../../shared";
import { PersonSelectorService } from "../../personselector/personselector.service";
import { ReportService } from "../../Report/report.service";
import { OverrideMTAComponent } from "../shared/override-mta/override-mta.component";
import { ReportFileTypeDialogComponent } from "../shared/report-file-type-dialog/report-file-type-dialog.component";
import { DataService_Student_Demographics } from "./shared/data.service";
import * as moment from "moment";

@Component({
	selector: "app-student-demographics",
	templateUrl: "./student-demographics.component.html",
	styleUrls: ["./student-demographics.component.css"],
})
export class StudentDemographicsComponent implements OnInit {
	constructor(
		private userService: UserService,
		private selectService: PersonSelectorService,
		private demographicsService: DataService_Student_Demographics,
		private reportService: ReportService,
		private dialogService: DialogService
	) {}

	ngOnInit(): void {
		this.user = this.userService.getCurrentUser();

		this.subscription = this.selectService.onPersonSelectChange().subscribe((person) => {
			this.SelectedPerson = person;
			this.loadDemographicsInfo();
		});
	}

	ngOnDestroy() {
		this.subscription.unsubscribe();
	}

	/////////////////////////////////////
	// Data
	/////////////////////////////////////

	user: any;

	//Person Selector
	subscription: Subscription;
	SelectedPerson: any;

	isProcessing: any = false;
	loading: any = false;

	errorMessage: any = "";

	Info: any;
	//Display
	Name: any = "";
	StudentID: any = "";
	PersonID: any = "";
	Gender: any = "";
	BirthDate: any = "";
	Ethnicity: any = "";
	Race: any = "";
	HomeLanguage: any = "";
	Address: any = "";
	CityStateZip: any = "";
	HomePhone: any = "";
	Cellphone: any = "";
	EMail: any = "";
	Cohort: any = "";
	Grade: any = "";
	Academy: any = "";
	Homeroom: any = "";
	Advisor: any = "";
	FinesOwed: any = "";
	MealsOwed: any = "";
	MealSubsidyType: any = "";
	IntensityLevel: any = "";
	Section504: any = "";
	IEP: any = "";
	EnrollmentDate: any = "";
	WithdrawalDate: any = "";
	BusNumber: any = "";
	SSNLabel: any = "Student SN";
	SSN: any = "";

	IsMTARider: any = false;
	PublicTransitLabel: string = "MTA";
	EnableMTA: any = false;
	EnablePARider: any = false;
	EnableMTAOverrideSchool: any = false;
	MTAOverride: any = false;
	OverrideReason: any = "";

	SchoolShowLastIDCard: any = false;
	IDCardSide1Enabled: any = false;
	IDCardSide2Enabled: any = false;
	IDCardSide1: any = "";
	IDCardSide2: any = "";
	SignatureData: any = "";
	isSigOnFile: boolean = false;
	lstCurrentReminder: any = [];
	lstBlockList: any = [];

	lstExtendedInfo: any = [];
	lstExtendedInfoLCol: any = [];
	lstExtendedInfoRCol: any = [];

	/////////////////////////////////////

	/////////////////////////////////////
	// Load Data
	/////////////////////////////////////
	loadDemographicsInfo() {
		this.loading = true;

		if (this.SelectedPerson == undefined) {
			this.loading = false;
			return;
		}

		var result = this.demographicsService.StudentGetFullInfo(this.SelectedPerson.PersonID);
		result.subscribe(
			(response: any) => {
				if (response != undefined && response.length > 0) {
					this.Info = response[0];
				}

				if (this.Info == undefined) {
					this.ResetData();
				} else {
					this.Name = this.Info.Name != "" ? this.Info.Name : "N/A";
					this.StudentID = this.Info.StudentID != "" ? this.Info.StudentID : "N/A";
					this.PersonID = this.Info.PersonID != "" ? this.Info.PersonID : "N/A";
					this.Gender = this.Info.Gender != "" ? this.Info.Gender : "N/A";
					this.BirthDate = this.Info.BirthDate != "" ? moment(new Date(this.Info.BirthDate)).format("MM/DD/YYYY") : "N/A";
					this.Ethnicity = this.Info.Ethnicity != "" ? this.Info.Ethnicity : "N/A";
					this.Race = this.Info.Race != "" ? this.Info.Race : "N/A";
					this.HomeLanguage = this.Info.HomeLanguage != "" ? this.Info.HomeLanguage : "N/A";
					this.Address = this.Info.Address != "" ? this.Info.Address : "N/A";
					this.CityStateZip = this.Info.CityStateZip != "" ? this.Info.CityStateZip : "N/A";
					this.HomePhone = this.Info.HomePhone != "" ? this.Info.HomePhone : "N/A";
					this.Cellphone = this.Info.Cellphone != "" ? this.Info.Cellphone : "N/A";
					this.EMail = this.Info.EMail != "" ? this.Info.EMail : "N/A";
					this.Cohort = this.Info.Cohort != "" ? this.Info.Cohort : "N/A";
					this.Grade = this.Info.Grade != "" ? this.Info.Grade : "N/A";
					this.Academy = this.Info.Academy != "" ? this.Info.Academy : "N/A";
					this.Homeroom = this.Info.Homeroom != "" ? this.Info.Homeroom : "N/A";
					this.Advisor = this.Info.Advisor != "" ? this.Info.Advisor : "N/A";
					this.FinesOwed = this.Info.FinesOwed != "" ? "$" + this.Info.FinesOwed : "N/A";
					this.MealsOwed = this.Info.MealsOwed != "" ? "$" + this.Info.MealsOwed : "N/A";
					this.MealSubsidyType = this.Info.MealSubsidyType != "" ? this.Info.MealSubsidyType : "N/A";
					this.IntensityLevel = this.Info.IntensityLevel != "" ? this.Info.IntensityLevel : "N/A";
					this.Section504 = this.Info.Section504 != "" ? this.Info.Section504 : "N/A";
					this.IEP = this.Info.IEP != "" ? this.Info.IEP : "N/A";
					this.EnrollmentDate = this.Info.EnrollmentDate != "" ? moment(new Date(this.Info.EnrollmentDate)).format("MM/DD/YYYY") : "N/A";
					this.WithdrawalDate = this.Info.WithdrawalDate != "" ? moment(new Date(this.Info.WithdrawalDate)).format("MM/DD/YYYY") : "N/A";
					this.BusNumber = this.Info.BusNumber != "" ? this.Info.BusNumber : "N/A";
					this.SSNLabel = this.Info.SSNLabel != "" ? this.Info.SSNLabel : "Student SN";
					this.SSN = this.Info.SSN != "" ? this.Info.SSN : "N/A";

					this.IsMTARider = this.Info.IsMTARider == 1 ? true : false;
					this.EnableMTA = this.Info.EnableMTA == 1 ? true : false;
					this.EnablePARider = this.Info.PARider == 1 ? true : false;
					this.EnableMTAOverrideSchool = this.Info.EnableMTAOverride == 1 ? true : false;
					this.MTAOverride = this.Info.MTAOverride == 1 ? true : false;

					this.PublicTransitLabel = this.Info.PublicTransitLabel;

					this.OverrideReason = this.Info.MTAOverrideReasonDesc;

					this.SchoolShowLastIDCard = this.Info.SchoolShowLastIDCard;
					this.IDCardSide1Enabled = this.Info.IDCardSide1Enabled;
					this.IDCardSide2Enabled = this.Info.IDCardSide2Enabled;
					this.IDCardSide1 = this.Info.IDCardSide1;
					this.IDCardSide2 = this.Info.IDCardSide2;
					this.SignatureData = this.Info.SignatureData;

					if (this.SignatureData == null)
					{
						this.isSigOnFile = false;
					}
					else
					{
						if (this.SignatureData.length > 100)
						{
							this.isSigOnFile = true;
						}
						else
						{
							this.isSigOnFile = false;
						}
					}

					this.lstCurrentReminder = this.Info.lstCurrentReminder;
					this.lstBlockList = this.Info.lstBlockList;

					this.lstExtendedInfo = [];
					this.lstExtendedInfoLCol = [];
					this.lstExtendedInfoRCol = [];

					if (this.Info.lstExtendedInfo != null) {
						this.lstExtendedInfo = this.Info.lstExtendedInfo;

						for (var z = 0; z < this.lstExtendedInfo.length; z++) {
							var next = this.lstExtendedInfo[z];

							if (z % 2 == 0) {
								this.lstExtendedInfoLCol = [...this.lstExtendedInfoLCol, next];
							} else {
								this.lstExtendedInfoRCol = [...this.lstExtendedInfoRCol, next];
							}
						}
					}
				}

				this.loading = false;
			},
			(error) => {
				this.loading = false;
				console.log(error);
			}
		);
	}

	ResetData() {
		this.Name = "N/A";
		this.StudentID = "N/A";
		this.PersonID = "N/A";
		this.Gender = "N/A";
		this.BirthDate = "N/A";
		this.Ethnicity = "N/A";
		this.Race = "N/A";
		this.HomeLanguage = "N/A";
		this.Address = "N/A";
		this.CityStateZip = "N/A";
		this.HomePhone = "N/A";
		this.Cellphone = "N/A";
		this.EMail = "N/A";
		this.Cohort = "N/A";
		this.Grade = "N/A";
		this.Academy = "N/A";
		this.Homeroom = "N/A";
		this.Advisor = "N/A";
		this.FinesOwed = "N/A";
		this.MealsOwed = "N/A";
		this.MealSubsidyType = "N/A";
		this.IntensityLevel = "N/A";
		this.Section504 = "N/A";
		this.IEP = "N/A";
		this.EnrollmentDate = "N/A";
		this.WithdrawalDate = "N/A";
		this.BusNumber = "N/A";

		this.IsMTARider = false;
		this.EnableMTA = false;
		this.EnablePARider = false;
		this.EnableMTAOverrideSchool = false;
		this.MTAOverride = false;

		this.OverrideReason = "";

		this.IDCardSide1 = "";
		this.IDCardSide2 = "";

		this.lstCurrentReminder = [];
		this.lstBlockList = [];

		this.lstExtendedInfo = [];
		this.lstExtendedInfoLCol = [];
		this.lstExtendedInfoRCol = [];

		// this.SSNLabel = "Student SN";
		this.SSN = "N/A";
	}
	/////////////////////////////////////

	/////////////////////////////////////
	// Buttons
	/////////////////////////////////////
	onPrint() {
		this.errorMessage = "";

		//Error handling

		if (this.SelectedPerson == undefined) {
			this.errorMessage = "Select a person to print demographics";
		}

		var ref = this.dialogService.open(ReportFileTypeDialogComponent, {
			header: "Report File Type",
			width: "fit-content",
			data: {},
		});
		ref.onClose.subscribe((response) => {
			if (response > 0) {
				this.FinishPrint(response);
			}
		});
	}

	FinishPrint(OutputType) {
		//Call SP

		var component = this;
		this.isProcessing = true;

		var strParam = "";

		//Parameter 1: PersonID
		strParam += this.SelectedPerson.PersonID + "|PersonID";

		var reportID: any = 205;

		//Add type selector
		var result = this.reportService.Print(reportID, strParam, this.SelectedPerson.SchoolID, OutputType);

		result.subscribe(
			(response: any) => {
				component.isProcessing = false;
				window.open(response);
			},
			(error) => {
				component.errorMessage = error;
				component.isProcessing = false;
			}
		);
	}
	/////////////////////////////////////

	/////////////////////////////////////
	// Events
	/////////////////////////////////////
	onOverrideMTAClick(val) {
		this.MTAOverride = !this.MTAOverride;

		var headerMsg: any = "Override " + this.PublicTransitLabel + " Rider Status";

		var ref = this.dialogService.open(OverrideMTAComponent, {
			header: headerMsg,
			width: "fit-content",
			data: {
				StudentName: this.Name,
				StudentID: this.StudentID,
				EnableMTA: this.EnableMTA,
				EnablePARider: this.EnablePARider,
				PublicTransitLabel: this.PublicTransitLabel,
			},
		});
		ref.onClose.subscribe((response) => {
			if (response == 1) {
				this.loadDemographicsInfo();
			} else {
				this.MTAOverride = !this.MTAOverride;
			}
		});
	}
	/////////////////////////////////////

	/////////////////////////////////////
	// Helpers
	/////////////////////////////////////

	IsSU() {
		if (this.user == undefined) {
			return false;
		} else {
			return this.user.userID == 0;
		}
	}

	IsLoading() {
		return this.loading == true || this.isProcessing == true;
	}

	/////////////////////////////////////
}
